export default __webpack_public_path__ + "static/media/earningIcon.5d53dde2.svg";